const resources = {
    pageTitle: 'Autoriser l’accès à votre compte Beauty Insider',
    whatCanDo: 'Ce que ChatGPT peut faire',
    permission1: 'Recommander des produits que vous adorerez',
    permission2: 'Trouver et magasiner vos favoris plus rapidement',
    permission3: 'Découvrir les marques et les rituels qui vous conviennent',
    permission4: 'Access and update your Sephora shopping cart',
    allowAccessButton: 'Autoriser l’accès',
    cancelButton: 'Annuler',
    manageAccessText: 'Vérifiez ou supprimez l’accès en tout temps dans vos paramètres ChatGPT en vous déconnectant de l’appli Sephora.',
    privacyPrefix: 'Pour plus de détails sur l’utilisation de vos données par ChatGPT, consultez la',
    chatGPTPrivacyPolicy: 'politique de confidentialité de ChatGPT',
    privacyMiddle: '. Pour savoir comment Sephora protège vos renseignements, consultez la',
    sephoraPrivacyPolicy: 'politique de confidentialité de Sephora,',
    privacyEnd: '.',
    sessionIdNotFound: 'L’identifiant de la session est introuvable. Veuillez recommencer le processus d’autorisation.',
    authorizationFailed: 'L’autorisation a échoué. Veuillez essayer de nouveau.',
    pageTitleGuest: 'Utiliser ChatGPT avec Sephora',
    permissionGuest1: 'Découvrir les essentiels et les marques',
    permissionGuest2: 'Comparer les options et recevoir des recommandations',
    permissionGuest3: 'Découvrir des rituels, des conseils et de l’inspiration',
    personalizedHeader: 'Vous souhaitez une expérience plus personnalisée?',
    personalizedText: 'Connectez votre compte Beauty Insider pour personnaliser les résultats en fonction de ce que vous aimez et achetez.',
    continueButton: 'Continuer',
    backButtonAriaLabel: 'Retour'
};

export default function getResource(label) {
    return resources[label];
}
